import { useSearchParams } from "react-router-dom";
import { DashboardFilterProvider } from "@/contexts/DashboardFilterContext";
import AdminLeadCard from "./AdminLeadCard";
import LeadActivityTable from "./LeadActivityTable";
import LeadListsTable from "./LeadListsTable";
import LeadQueueOverview from "./LeadQueueOverview";
import LeadRulesButton from "./LeadRulesButton";
import PoolLeadsView from "./PoolLeadsView";
import RejectedLeadsButton from "./RejectedLeadsButton";

/**
 * Leadlister-fanen (VIB-2988): ringeaktivitet per møtebooker og listene med statistikk.
 * Egen menynøkkel salgsmuligheter.leadlister, så de som ringer ikke ser dette.
 * VIB-3050: bookerkøene og reglene, leads i en pool (?pool=) og leadkort for admin (?lead=).
 */
export default function LeadListsTab() {
  const [params, setParams] = useSearchParams();
  const poolId = params.get("pool");
  const leadId = params.get("lead");
  const go = (next: Record<string, string>) => setParams(next);

  if (leadId) {
    return <AdminLeadCard leadId={leadId} onBackToPool={(id) => go({ pool: id })} onBackToPools={() => go({})} />;
  }
  if (poolId) {
    return <PoolLeadsView listId={poolId} onBack={() => go({})} onOpenLead={(id) => go({ lead: id })} />;
  }
  return (
    <div className="space-y-8">
      <div className="flex justify-end gap-2">
        <LeadRulesButton />
        <RejectedLeadsButton />
      </div>
      <LeadQueueOverview />
      <DashboardFilterProvider>
        <LeadActivityTable />
      </DashboardFilterProvider>
      <LeadListsTable onOpenPool={(id) => go({ pool: id })} />
    </div>
  );
}
